import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useState } from 'react';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Button } from '../../subkit-ui';
import { AcceptTerms } from '../AcceptTerms/';
import { TWInput } from '../TWInput';
import isEmpty from 'lodash/isEmpty';
import PromoCode from './PromoCode';
import { validateName } from '../../utils/helpers'; // Custom styling can be passed to options when creating an Element.

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CARD_ELEMENT_OPTIONS = {
  classes: {
    base: 'border border-gray-300 rounded py-3 px-4'
  },
  style: {
    base: {
      width: '100%',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#676767'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  }
};
export var NewCardForm = function NewCardForm(_ref) {
  var title = _ref.title,
      buttonText = _ref.buttonText,
      providerService = _ref.providerService,
      serverError = _ref.serverError,
      userAgreedToSubkitTerms = _ref.userAgreedToSubkitTerms,
      userNameExists = _ref.userNameExists,
      userId = _ref.userId,
      updateUser = _ref.updateUser,
      onCreateToken = _ref.onCreateToken,
      icon = _ref.icon,
      order = _ref.order,
      getOrder = _ref.getOrder,
      updateOrder = _ref.updateOrder,
      isSubscription = _ref.isSubscription;

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(false),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  var _useState3 = useState(false),
      receiveServiceEmails = _useState3[0],
      setReceiveServiceEmails = _useState3[1];

  var _useState4 = useState(false),
      acceptServiceTerms = _useState4[0],
      setAcceptServiceTerms = _useState4[1];

  var _useState5 = useState({
    firstName: '',
    lastName: ''
  }),
      userInfo = _useState5[0],
      setUserInfo = _useState5[1];

  var handleAcceptServiceTerms = function handleAcceptServiceTerms() {
    setAcceptServiceTerms(!acceptServiceTerms);
    updateValidity({
      acceptServiceTerms: !acceptServiceTerms
    });
  };

  var handleReceiveServiceEmails = function handleReceiveServiceEmails() {
    setReceiveServiceEmails(!receiveServiceEmails);
  };

  var renderedError = error || serverError;
  var stripe = useStripe();
  var elements = useElements(); // Handle real-time validation errors from the card Element.

  var handleChange = function handleChange(event) {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError(null);
    }
  };

  var createCardToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cardNumber, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cardNumber = elements.getElement(CardElement);
              _context.next = 3;
              return stripe.createToken(cardNumber);

            case 3:
              result = _context.sent;

              if (!result.error) {
                _context.next = 9;
                break;
              }

              // Inform the user if there was an error.
              setError(result.error.message);
              return _context.abrupt("return", Promise.reject(result.error));

            case 9:
              setError(null);
              return _context.abrupt("return", onCreateToken(receiveServiceEmails, result.token.id));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createCardToken() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(evt) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              evt.preventDefault();
              payload = {};

              if (userInfo.firstName) {
                payload.firstName = userInfo.firstName;
              }

              if (userInfo.lastName) {
                payload.lastName = userInfo.lastName;
              }

              payload.agreedToTerms = acceptServiceTerms;

              if (isEmpty(payload)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return updateUser(userId, payload);

            case 8:
              return _context2.abrupt("return", createCardToken());

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleUserInfoChange = function handleUserInfoChange(event) {
    var nextUserInfo = _objectSpread(_objectSpread({}, userInfo), {}, _defineProperty({}, event.target.name, event.target.value));

    setUserInfo(nextUserInfo);
    updateValidity(nextUserInfo);
  };

  var updateValidity = function updateValidity(validationInfo) {
    var validity = _objectSpread(_objectSpread({
      acceptServiceTerms: acceptServiceTerms
    }, userInfo), validationInfo);

    var nextIsValid = validity.acceptServiceTerms;

    if (!userNameExists) {
      nextIsValid = validateName(validity.firstName) && validateName(validity.lastName) && nextIsValid;
    }

    setIsValid(nextIsValid);
  };

  return /*#__PURE__*/_jsxs("form", {
    name: "paymentMethod",
    children: [title && /*#__PURE__*/_jsx("h2", {
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-4",
      children: [!userNameExists && /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col md:flex-row w-full mb-8",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-full mb-8 md:mb-0 md:w-1/2 md:pr-2.5",
          children: /*#__PURE__*/_jsx(TWInput, {
            format: "rounded",
            label: "First Name",
            placeholder: "Jacob",
            name: "firstName",
            value: userInfo.firstName,
            onChange: handleUserInfoChange,
            onBlur: updateValidity,
            dataCy: "first-name"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full md:w-1/2 md:pl-2.5",
          children: /*#__PURE__*/_jsx(TWInput, {
            format: "rounded",
            label: "Last Name",
            placeholder: "Andrews",
            name: "lastName",
            value: userInfo.lastName,
            onChange: handleUserInfoChange,
            onBlur: updateValidity,
            dataCy: "last-name"
          })
        })]
      }), /*#__PURE__*/_jsx("label", {
        htmlFor: "card-number",
        className: "block text-base font-medium text-gray-700 mb-1",
        children: "Card Information"
      }), /*#__PURE__*/_jsx(CardElement, {
        id: "card-number",
        options: CARD_ELEMENT_OPTIONS,
        onChange: handleChange
      })]
    }), renderedError && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("p", {
        className: "text-red-900 fw-500",
        children: renderedError.toString()
      })
    }), (order === null || order === void 0 ? void 0 : order.planId) && !!getOrder && !!updateOrder && /*#__PURE__*/_jsx("div", {
      className: "mt-2 mb-6",
      children: /*#__PURE__*/_jsx(PromoCode, {
        order: order,
        getOrder: getOrder,
        updateOrder: updateOrder
      })
    }), /*#__PURE__*/_jsx(AcceptTerms, {
      handleAcceptServiceTerms: handleAcceptServiceTerms,
      handleReceiveServiceEmails: handleReceiveServiceEmails,
      receiveServiceEmails: receiveServiceEmails,
      acceptServiceTerms: acceptServiceTerms,
      providerService: providerService,
      userAgreedToSubkitTerms: userAgreedToSubkitTerms,
      isSubscription: isSubscription
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-4 md:mb-0 md:w-64",
      children: /*#__PURE__*/_jsx(Button, {
        size: "lg",
        onClick: onSubmit,
        disabled: isSubscription ? !isValid || !receiveServiceEmails : !isValid,
        text: buttonText,
        icon: icon,
        iconType: "solid",
        loadingText: "Loading",
        "data-cy": buttonText
      })
    })]
  });
};
NewCardForm.defaultProps = {
  title: '',
  buttonText: 'Confirm and Pay',
  showFooter: true
};